import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSignOut$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSignOut extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '616a145e01fe8b07ba9c3f1c0b85d868339460d6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a63e7acef6bde0e557d3fc7470b92472a291ae35', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c0a281b70a69dc3d12600b216959308321d5811f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.5 16.5v3a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-2H3.5v15H12v-2a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5m2.223-1.444a.48.48 0 0 1-.298-.446v-2.86h-8.89c-.295 0-.535-.224-.535-.5v-.5c0-.276.24-.5.536-.5h8.89V7.39a.482.482 0 0 1 .823-.341l3.61 3.61a.48.48 0 0 1 0 .682l-3.61 3.61a.48.48 0 0 1-.526.105", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sign-out", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sign-out"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sign-out":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSignOut$1);
            }
            break;
    } });
}

const CosmosIconSignOut = CosmosIconSignOut$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSignOut, defineCustomElement };
